/**
 * Runs `task` while holding a Web Lock shared by every tab of this origin, so only one tab runs it at a time. Where the Web Locks API is missing, runs it directly.
 */
export function withCrossTabLock<T>(name: string, task: () => Promise<T>): Promise<T> {
  if (typeof navigator === 'undefined' || !navigator.locks) return task();
  // The DOM typings type the callback's result as the lock's result, so a promise-returning task reads as Promise<Promise<T>>; the lock resolves with the awaited value.
  return navigator.locks.request(name, task) as Promise<T>;
}
